"use client";
import { Typography } from "@/components/custom/typography";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { useUpdateUserLanguage } from "@/hooks/useLanguage";
import { cn, isEmptyObject } from "@/lib/utils";
import { useUser } from "@/stores/user";
import { useLocale } from "next-intl";
import { useRouter } from "next/navigation";
import { useEffect, useState } from "react";

export default function LocaleSwitcher({
  className = "",
  hiddenTextPrefix = false,
}: {
  className?: string;
  hiddenTextPrefix?: boolean;
}) {
  const router = useRouter();
  const { userInfo } = useUser();
  const fallbackLocale = useLocale();
  const currentLocale = userInfo?.user?.lang ?? fallbackLocale;

  const [lang, setLang] = useState(currentLocale);
  const { mutate: updateLanguage } = useUpdateUserLanguage();

  const handleChange = (value: string) => {
    setLang(value);
    document.cookie = `NEXT_LOCALE=${value}; path=/`;
    router.refresh();
    // Save to server
    if (!isEmptyObject(userInfo?.user)) {
      updateLanguage(value)
    }
  };

  useEffect(() => {
    // user.lang이 있을 때만 쿠키 업데이트 (없으면 기존 쿠키 유지)
    if (userInfo?.user?.lang) {
      document.cookie = `NEXT_LOCALE=${currentLocale}; path=/`;
      router.refresh();
    }
  }, []);

  return (
    <Select value={lang} onValueChange={(value) => handleChange(value)}>
      <SelectTrigger
        className={cn(
          "text-gray-500 font-medium w-43 p-3 rounded-md border-secondary-500 !gap-0",
          className
        )}
      >
        <div className="flex items-center gap-1">
          {!hiddenTextPrefix && "Language"}
          <Typography className="text-gray-500">
            (
            <SelectValue defaultValue={currentLocale} />)
          </Typography>
        </div>
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="kr">KR</SelectItem>
        <SelectItem value="en">EN</SelectItem>
      </SelectContent>
    </Select>
  );
}
